import { useMutation } from 'react-query';
import { backend } from '../axios/backend';
import { useAppContext } from '../context/AppContext';
import { parseErrorMessage } from '../utils/error-message';
import Button from './ui/Button';

const NotVerifiedAlert = () => {
  const { alertError, alertSuccess } = useAppContext();
  const mutation = useMutation(() => backend.patch('/auth/resend-email-verification'), {
    onError: (e) => alertError(parseErrorMessage(e)),
    onSuccess: () => alertSuccess('Verifikations-Email erneut gesendet.'),
  });

  return (
    <div
      id="alert-additional-content-4"
      className="p-4 mb-4 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-yellow-200"
      role="alert"
    >
      <div className="flex items-center">
        <svg
          aria-hidden="true"
          className="w-5 h-5 mr-2 text-yellow-700 dark:text-yellow-800"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"
          ></path>
        </svg>
        <span className="sr-only">Info</span>
        <h3 className="text-lg font-medium text-yellow-700 dark:text-yellow-800">Email Adresse validieren</h3>
      </div>
      <div className="mt-2 mb-4 text-sm text-yellow-700 dark:text-yellow-800">
        Bei der Registrierung haben wir dir eine Mail zur Validierung deiner Email Adresse geschickt. Bitte validiere
        deine Email Adresse mit dieser Email.
      </div>
      <div className="flex">
        <Button
          variant="alternative"
          isLoading={mutation.isLoading}
          isDisabled={mutation.isSuccess}
          onClick={() => mutation.mutate()}
        >
          Email erneut zusenden
        </Button>
      </div>
    </div>
  );
};

export default NotVerifiedAlert;
